
import { defineComponent, ref, computed } from 'vue';
import { message } from 'ant-design-vue';
import { formatWithIntl } from '@/utils/illuminate';
import { request } from '@/utils/request';
import { createApiUrl } from '@/utils/utils';
import { invoiceTypeMap } from '@/views/fapiao/parts/utils';

export default defineComponent({
  name: 'RedFlushApplyModal',
  emits: ['complete'],
  setup(props, ctx) {
    const visible = ref(false);
    const submitting = ref(false);
    const step = ref<'pre' | 'next'>('pre');
    const remark = ref('');
    const record = ref<Record<string, any>>({});

    // 由“红冲失败(5)”再次进入时标题为“重新申请发票红冲”
    const title = computed(() => (record.value.invoiceStatus === 5 ? '重新申请发票红冲' : '申请发票红冲'));

    // 红冲备注填写后方可进入下一步
    const canGoNext = computed(() => !!(remark.value && remark.value.trim()));

    const closeModal = () => {
      visible.value = false;
      step.value = 'pre';
      remark.value = '';
      record.value = {};
    };

    const open = (item: any) => {
      record.value = item;
      remark.value = '';
      step.value = 'pre';
      visible.value = true;
    };

    const toNext = () => {
      if (!remark.value.trim()) return message.warning('请填写红冲备注');
      step.value = 'next';
    };

    const toPre = () => {
      step.value = 'pre';
    };

    const onSubmit = async () => {
      try {
        submitting.value = true;
        await request.post(createApiUrl('/newlinkSass/invoice/red-flush-apply'), {
          invoiceRecordId: record.value.invoiceRecordId,
          remark: remark.value.trim(),
        });
      } catch (e: Error & any) {
        submitting.value = false;
        return message.error(e.message);
      }
      submitting.value = false;
      message.success('红冲申请已提交，请等待审核');
      closeModal();
      ctx.emit('complete');
    };

    return {
      visible,
      submitting,
      step,
      remark,
      record,
      title,
      canGoNext,
      invoiceTypeMap,
      formatWithIntl,
      open,
      closeModal,
      toNext,
      toPre,
      onSubmit,
    };
  },
});
